import { InputCheckboxItemComponent } from './input-checkbox-item.component';

export default angular
  .module('sfMobile.components.input-checkbox-item', [
    'sfMobile.components.input-checkbox',
  ])
  .component('sfInputCheckboxItem', InputCheckboxItemComponent).name;
